/* eslint-disable */

import { HiX } from "react-icons/hi";
import Links from "./components/Links";
import {useNavigate } from 'react-router-dom';
import {BiLogOut} from "react-icons/bi";

import routes from "../../routes/routes.js";

const Sidebar = ({ open, onClose }) => {
  let navigateTo = useNavigate();

  const logout = () => {
    const requestOptions = {
      method: 'DELETE',
      headers: {
        'Authorization': 'Bearer '+ localStorage.getItem('token')
      }
    };

    fetch(process.env.REACT_APP_API_URL+"/v1/logout", requestOptions)
        .catch((error) => {
          console.log(error);
        });
    localStorage.clear();
    navigateTo("/auth/sign-in");
  };

  return (
      <div
          className={`sm:none duration-175 linear fixed !z-50 flex min-h-full flex-col bg-white pb-10 shadow-2xl shadow-white/5 transition-all dark:!bg-navy-800 dark:text-white md:!z-50 lg:!z-50 xl:!z-0 ${
              open ? "translate-x-0" : "-translate-x-96"
          }`}
      >
      <span
          className="absolute top-4 right-4 block cursor-pointer xl:hidden"
          onClick={onClose}
      >
        <HiX/>
      </span>

        <div className={`mx-[50px] mt-[24px] flex items-center`}>
          <div className="ml-1 h-1 text-[24px] font-bold uppercase text-navy-700 dark:text-white">
            BRISA MDC
          </div>
        </div>
        <div className="mt-[58px] mb-7 h-px bg-gray-300 dark:bg-white/30"/>
        {/* Nav item */}

        <ul className="mb-auto pt-1">
          <Links routes={routes}/>
        </ul>
        <div className="fixed bottom-10">
          <ul className="mb-auto pt-1">
            <button onClick={logout}>
              <div className="relative mb-3 flex hover:cursor-pointer">
                <li
                    className="my-[3px] flex cursor-pointer items-center px-8"
                    key="12"
                >
                <span
                    className="font-bold text-brand-500 dark:text-white"
                >
                  <BiLogOut className="h-6 w-6"/>
                </span>
                  <p
                      className="leading-1 ml-4 flex font-bold text-navy-700 dark:text-white"
                  >
                    Logout
                  </p>
                </li>

              </div>
            </button>
          </ul>
        </div>


        {/* Nav item end */}
      </div>
  );
};

export default Sidebar;
